module.exports = __webpack_public_path__ + "img/actOne.9419b0be.png";